// UnauthenticatedLayout.tsx
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Box, Container } from "@mui/material";
import { PropsWithChildren } from "react";

export type LayoutProps = PropsWithChildren<{
  topBarComponent?: React.ReactNode;
}>;

export const Layout: React.FC<LayoutProps> = ({
  children,
  topBarComponent,
}) => {
  return (
    <Box
      component="nav"
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      {topBarComponent}
      <Grid
        container
        spacing={0}
        sx={{
          bgcolor: "background.default",
        }}
      >
        <Grid size="grow">
          <Container sx={{ px: { xs: 1, sm: 3 } }}>{children || <Outlet />}</Container>
        </Grid>
      </Grid>
    </Box>
  );
};


